import {
  DELIVERY_TYPE_TAKEAWAY,
  REQUEST_INITIAL,
  REQUEST_SUCCESS,
  REQUEST_INPROGRESS,
  REQUEST_ERROR,
} from 'store/constants';
import { TabEnum } from 'store/ProductDetails/constants';

import {
  SET_ACTIVE_SECTION,
  SET_DELIVERY_ACTIVE_SECTION,
  SET_DELIVERY_TAKEAWAY_SEARCH_QUERY,
  SET_DELIVERY_ACTIVE_POINT,
  DELIVERY_PICKUP_OPEN,
  DELIVERY_PICKUP_VIEW,
  DELIVERY_PICKUP_SUCCESS,
  DELIVERY_PICKUP_LOADING,
  DELIVERY_PICKUP_ERROR_DETAILS,
  FANCY_NUMBERS_SET,
  FANCY_NUMBERS_SET_ACTIVE,
  TOGGLE_FANCYNUMBER,
  FANCY_NUMBERS_REQUEST,
  FANCY_NUMBERS_FAIL,
  PRODUCT_DETAILS_IS_FAVORITE,
  SET_IS_BUNDLE_SWITCHED,
} from './constants';

const initialState = {
  hasCredit: false,
  creditName: null,
  isProductFavorite: false,
  currentSection: TabEnum.CONTENT_TAB_ABOUT,
  currentDeliverySection: DELIVERY_TYPE_TAKEAWAY,
  deliveryTakeawaySearchQuery: '',
  deliveryPickupOpenState: false,
  deliveryPickupPoint: null,
  deliveryPickupViewState: 'form',
  deliveryPickupSuccess: {
    name: '',
    phone: '',
    orderId: '',
    price: '',
    title: '',
    pointAddress: '',
    pointOpening: '',
  },
  deliveryPickupLoading: false,
  deliveryPickupErrorDetails: {
    headline: 'Произошла ошибка',
    message: 'Попробуйте позднее.',
  },
  fancyNumbers: [],
  fancyNumbersIndex: 0,
  fancyNumbersStatus: REQUEST_INITIAL,
  toggleFancyNumber: false,
  isBundleSwitched: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_SECTION: {
      const { payload: currentSection } = action;

      return {
        ...state,
        currentSection,
      };
    }
    case SET_DELIVERY_ACTIVE_SECTION: {
      const { payload: currentDeliverySection } = action;
      return {
        ...state,
        currentDeliverySection,
      };
    }
    case SET_DELIVERY_TAKEAWAY_SEARCH_QUERY: {
      const { value } = action;
      return {
        ...state,
        deliveryTakeawaySearchQuery: value,
      };
    }
    case PRODUCT_DETAILS_IS_FAVORITE: {
      return {
        ...state,
        isProductFavorite: action.payload,
      };
    }
    case SET_DELIVERY_ACTIVE_POINT: {
      return {
        ...state,
        deliveryPickupPoint: action.payload,
      };
    }
    case DELIVERY_PICKUP_OPEN: {
      return {
        ...state,
        deliveryPickupOpenState: action.payload,
      };
    }
    case DELIVERY_PICKUP_VIEW: {
      return {
        ...state,
        deliveryPickupViewState: action.payload,
      };
    }
    case DELIVERY_PICKUP_SUCCESS: {
      return {
        ...state,
        deliveryPickupSuccess: action.payload,
      };
    }
    case DELIVERY_PICKUP_LOADING: {
      return {
        ...state,
        deliveryPickupLoading: action.payload,
      };
    }
    case DELIVERY_PICKUP_ERROR_DETAILS: {
      return {
        ...state,
        deliveryPickupErrorDetails: {
          headline: action.payload.Subject,
          message: action.payload.Message,
        },
      };
    }

    case FANCY_NUMBERS_REQUEST: {
      return {
        ...state,
        fancyNumbersStatus: REQUEST_INPROGRESS,
      };
    }
    case FANCY_NUMBERS_SET: {
      return {
        ...state,
        fancyNumbersStatus: REQUEST_SUCCESS,
        fancyNumbers: action.payload,
      };
    }
    case FANCY_NUMBERS_FAIL: {
      return {
        ...state,
        fancyNumbersStatus: REQUEST_ERROR,
      };
    }
    case FANCY_NUMBERS_SET_ACTIVE: {
      return {
        ...state,
        fancyNumbersIndex: action.payload,
      };
    }
    // TODO: remove fancy numbers
    case TOGGLE_FANCYNUMBER: {
      return {
        ...state,
        toggleFancyNumber: action.payload,
      };
    }
    case SET_IS_BUNDLE_SWITCHED: {
      return {
        ...state,
        isBundleSwitched: action.payload,
      };
    }
    default:
      return state;
  }
}
